export enum Origin {
  PasswordReset = "password-reset",
  SessionTimeout = "session-timeout",
  DeveloperDetailsPreview = "developer-details-preview",
  VerifierDetailsPreview = "verifier-details-preview",
  DevelopmentManagerDetailsPreview = "development-manager-details-preview",
  ProjectAuditPage = "project-audit-page",
  OrganisationAuditPage = "organisation-audit-page",
  DeveloperDashboardPage = "developer-dashboard-page",
  DashboardPage = "dashboard-page",
  ProjectTrackerPage = "project-tracker-page",
  DeveloperActivitiesPage = "developer-activities-page",
  LandholdingDetailsPage = "landholding-details-page",
  WorkflowsPage = "workflows-page",
  ProjectTasksPage = "project-tasks-page",
}
